import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import Share, { DropDownMenu, DropdownToggle } from '@/components/Share';
import ArrowIcon from '@/assets/svg/detailed-car/arrow.svg';
import { colors } from '@/constants/theme';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';
import defaultStockCar from '@/assets/images/cars-stock/defaultStockCar.png';

function MobileNavigation() {
  const router = useRouter();

  function handleClick() {
    router.back();
  }

  const data = useTypedSelector(selectDetailedCarData);

  if (!data) {
    return null;
  }

  const {
    media: { images },
  } = data;

  const image = images.length ? images[0] : defaultStockCar;

  return (
    <Component>
      <BackButton onClick={handleClick}>
        <IconWrapper>
          <ArrowIcon />
        </IconWrapper>
        <ButtonTitle>Назад</ButtonTitle>
      </BackButton>
      <ShareWrapper>
        <Share path={`/cars/new/${data.id}`} image={image} />
      </ShareWrapper>
    </Component>
  );
}

export default MobileNavigation;

const Component = styled.div`
  display: flex;
  justify-content: space-between;

  ${DropDownMenu} {
    left: -170px;
  }

  ${DropdownToggle} {
    color: ${colors.black200};
  }
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
`;

const ButtonTitle = styled.span`
  margin-left: 15px;
  font-size: 16px;
  line-height: 19px;
  color: ${(props) => props.theme.gray700};
`;

const ShareWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: ${colors.white};
  border: 1px solid ${colors.gray100};
  border-radius: 50%;

  svg {
    width: 12px;
    height: 10px;
  }
`;

const IconWrapper = styled.div`
  svg {
    margin-top: 3px;
    transform: rotate(180deg);
    width: 7.6px;
    height: 13.3px;

    path {
      fill: ${(props) => props.theme.gray700};
    }
  }
`;
